export default __webpack_public_path__ + "static/media/uru.a415b4ce.svg";